import { render, staticRenderFns } from "./SectionSustainabilityV2.vue?vue&type=template&id=9b92db38&"
import script from "./SectionSustainabilityV2.vue?vue&type=script&lang=js&"
export * from "./SectionSustainabilityV2.vue?vue&type=script&lang=js&"
import style0 from "./SectionSustainabilityV2.vue?vue&type=style&index=0&id=9b92db38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,OrganismsCommonOrganismCertifications: require('/app/components/organisms/common/OrganismCertifications.vue').default})
